"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BlockLabel_1 = require("../BlockLabel");
var getBlockLabelProps_1 = require("../../../utils/getBlockLabelProps");
var Typo2_1 = require("../Typo2");
var useDatePickerState_1 = require("./utils/useDatePickerState");
var styled_1 = require("./styled");
require("react-datepicker/dist/react-datepicker.css");
function DatePicker_(props) {
    var value = props.value, onChange = props.onChange, readOnly = props.readOnly, disabled = props.disabled, _a = props.withPortal, withPortal = _a === void 0 ? false : _a, _b = props.portalId, portalId = _b === void 0 ? 'date-picker-portal' : _b, minDate = props.minDate, maxDate = props.maxDate, pickerLabel = props.pickerLabel;
    var _c = (0, useDatePickerState_1.useDatePickerState)({
        withPortal: withPortal,
        portalId: portalId,
        onDateSelect: onChange
    }), datePickerProps = _c.datePickerProps, isOpen = _c.isOpen;
    var baseProps = __assign({ className: 'UI_BODY_SM', selected: value, minDate: minDate, maxDate: maxDate, readOnly: readOnly, disabled: disabled, dateFormat: "MM/dd/yyyy" }, datePickerProps);
    return (react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column" } },
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        react_1.default.createElement("div", { style: {} },
            pickerLabel && react_1.default.createElement(Typo2_1.UI_CAPTION, null, pickerLabel),
            react_1.default.createElement(styled_1.StyledDatePicker, __assign({}, baseProps))),
        props.debug && (react_1.default.createElement("pre", null, JSON.stringify({ value: value }, null, 2)))));
}
exports.default = react_1.default.memo(DatePicker_);
